const NonconformanceTypes = () => import("Modules/configuration/nonconformance_types/views/NonconformanceTypes");

// ROUTE OPTION - `pathToRegexpOptions: { strict: true }` makes trailing slashes fail to match path
export default {
    children: [
        {
            path: "configuration/nonconformance_types",
            name: "settings_nonconformance_types",
            component: NonconformanceTypes,
            meta: {
                requiresAuth: true,
                title: "lang.nonconformance_types",
                restrict_by_login_type: ["employee"],
                restrict_by_permission: ["configuration.read"],
            },
        },
    ],
};
